import { useTranslation } from "react-i18next";
import Header from "../../../components/common/layout/Header";
import MapComponent from "../../../components/passenger/map/Map";
import { Helmet } from "react-helmet";
import { useSitemap } from "../../../shared/hooks/use-sitemap";
import Canonical from "../../../components/common/layout/Canonical";

const Map = () => {
  const { t } = useTranslation('common');
  useSitemap();

  return (
    <>
      <Canonical />
      <Helmet>
        <title>{t("seo_friendly.map.title")}</title>
        <meta name="description" content={t("seo_friendly.map.desc")} />
      </Helmet>
      <div className="w-full h-full dark:bg-bgDarkDull bg-white">
        <Header type="passenger" />

        <div className="w-full h-full mms:h-[550px] xlx:h-[600px]" id="home">
          <MapComponent />
        </div>
      </div>
    </>
  );
};

export default Map;